import Axios from '@/api/http'
import { cloneDeep } from 'lodash'
/**
 * 获取仪表盘配置
 * */
export function getapprovaldashboard (date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovaldashboard',
    data: date
  })
}

/**
 * 获取应用可筛选字段
 * */
export function apiGetapprovalselect (date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalselect',
    data: date
  })
}

/**
 * 根据用户 id 获取用户详细信息
 * */
export function apiGetmiddleuserbyid (date) {
  return Axios({
    method: 'post',
    url: '/api/getmiddleuserbyid',
    data: date
  })
}

/**
 * 根据表单 id 获取表单层级信息
 * */
export function getappcategoryandlabel (date) {
  return Axios({
    method: 'post',
    url: '/api/getappcategoryandlabel',
    data: date
  })
}

/**
 * 查询能力管理列表
 * */
export function getcompetencymanagelist (date) {
  return Axios({
    method: 'post',
    url: '/api/getcompetencymanagelist',
    data: date
  })
}

/**
 * 仪表盘查询应用权限接口
 * */
export function getbuttonpermission (date) {
  return Axios({
    method: 'post',
    url: '/openapi/getbuttonpermission',
    data: date
  })
}

/**
 * 仪表盘汇总修改接口
 * */
export function updatesummfeilds (date) {
  return Axios({
    method: 'post',
    url: '/openapi/updatesummfeilds',
    data: date
  })
}

/**
 * 查询最新表格结果
 * */
export function apiUpateview (date, type = 'detailed') {
  return Axios({
    method: 'post',
    url: '/api/getapprovaldashboarddatalist',
    data: date,
    interceptUrl: true
  }).then(res => {
    if (res.code === 0) {
      if (res.data.list.length > 0) {
        let datas = res.data.list.map((item, index) => {
          if(type === 'detailed') item.index = index
          return item
        })
        res.data.originalDatas = cloneDeep(datas)
        const user = []
        for (let i = 0; i < datas.length; i++) {
          user[i] = {}
          if (datas[i]) {
            for (let a in datas[i]) {
              // 值里面包含userId就直接另存出来
              if (Array.isArray(datas[i][a])) {
                if (datas[i][a][0] && datas[i][a][0].userId) {
                  user[i][a] = datas[i][a]
                }
              } else if (typeof datas[i][a] === "object") {
                if (datas[i][a].userId) {
                  user[i][a] = datas[i][a]
                } else {
                  for (const s in datas[i][a]) {
                      if (Array.isArray(datas[i][a][s])) {
                        if (datas[i][a][s][0] && datas[i][a][s][0].userId) {
                          user[i][a + '.' + s] = datas[i][a][s]
                        } else if (datas[i][a][s][0] && datas[i][a][s][0].roleId) {
                          user[i][a + '.' + s] = datas[i][a][s]
                        } else if (datas[i][a][s][0] && datas[i][a][s][0].organizationId) {
                          user[i][a + '.' + s] = datas[i][a][s]
                        }
                      } else if (typeof datas[i][a][s] === "object") {
                        if (datas[i][a][s].userId) {
                          user[i][a + '.' + s] = datas[i][a][s]
                        }
                    }
                  }
                }
              }
              datas[i][a] = reportpreviewResult(datas[i][a], a);
            }
          }
        }
        if (user.length > 0) res.user = user
      }
    }
    return res;
  })
}


/**
 * 数据选择使用的存储接口
 * */
export function importapprovaldashboarddatalist (date) {
  return Axios({
    method: 'post',
    url: '/api/importapprovaldashboarddatalist',
    data: date,
    interceptUrl: true,
    timeout: 1000 * 60 * 2,
  }).then(res => {
    return res;
  })
}

/**
 * 下载最新表格结果
 * */
export function apiUploadview (date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovaldashboarddatalist',
    data: date,
    interceptUrl: true,
    timeout: 1000 * 60 * 2,
  }).then(res => {
    return res;
  })
}

/**
 * 查询表格，不转数据的
 */
export function apiGetapprovaldashboardpreviewNoDate (date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovaldashboardpreview',
    data: date,
    interceptUrl: true
  })
}
/**
 * 查询表格结果
 * */
export function apiGetapprovaldashboardpreview (date, configList) {
  return Axios({
    method: 'post',
    url: '/api/getapprovaldashboardpreview',
    data: date,
    interceptUrl: true
  }).then(res => {
    if (res.code === 0) {
      const user = []
      let c = false
      const orj = {}
      if (configList && configList.length > 0) {
        for (const j of configList) {
          const n = j.revisabilityName || j.name
          orj[n] = j.type
        }
      }
      for (let i = 0; i < res.data.length; i++) {
        const e = {}
        if (res.data[i]) {
          for (let a in res.data[i]) {
            if (res.data[i][a] && JSON.stringify(res.data[i][a]).includes('userId')) {
              c = true
              e[a] = res.data[i][a]
            }
            if (orj[a] && (orj[a] === 'text' || orj[a] === 'textarea') && typeof res.data[i][a] !== 'string') res.data[i][a] = JSON.stringify(res.data[i][a])
            res.data[i][a] = reportpreviewResult(res.data[i][a], a);
          }
        }
        user.push(e)
      }
      if (c) res.user = user
    }
    return res;
  })
}

export function reportpreviewResult (res, a) {
  //apiGetapprovalreportpreviews接口数据处理使用
  if (res instanceof Object) {//如果为对象
    if (res instanceof Array) {//如果为数组
      let realname = []
      res.forEach(ele => {
        if (ele.realname) {
          realname.push(ele.response && ele.response.includes('/userfiles/') ? {response:ele.response} : ele.realname)
        }
      });
      res = realname.length > 0 ? realname : res
    } else {//为对象
      let obs = {}
      if (res.realname) {
        res = res.realname
        if (res.userId) {
          obs[res.userId] = res
        }
      }else {
        for (let b in res) {
          res[b] = reportpreviewResult(res[b], b);
        }
      }
    }
  }

  if (a === '状态' && typeof (res) === "number") {
    let arr = ['进行中', '已通过', '未通过', '已撤销'];
    if (arr[res]) res = arr[res];
  } else if (a === '归档状态' && typeof (res) === "number") {
    const ars = ['未归档', '已归档']
    if (ars[res]) res = ars[res]
  } else if (a === '存证状态' && typeof (res) === "number") {
    const ars = ['未存证', '', '已存证']
    if (ars[res]) res = ars[res]
  } else if (a === '预支付状态' && typeof (res) === "number") {
    const ars = ['未支付', '已支付']
    if (ars[res]) res = ars[res]
  } else if (a === '支付状态' && typeof (res) === "number") {
    const ars = ['未支付', '支付成功', '支付失败']
    if (ars[res]) res = ars[res]
  }
  // console.log("装换值后。",res)
  return res;
}


/*
* 获取echart配置信息列表
*/

export const getechartsconfiglist = (data) => {
  return Axios({
    method: 'post',
    url: '/api/getechartsconfiglist',
    data
  })
}


/*
* 删除echart配置信息
*/

export const deleteechartsconfig = (id) => {
  return Axios({
    method: 'post',
    url: '/api/deleteechartsconfig',
    data: {
      id
    }
  })
}

/*
* 删除个人或者全部最新数据
*/

export const deletelastrecentdata = (data) => {
  return Axios({
    method: 'post',
    url: '/api/deletelastrecentdata',
    data: data
  })
}
/*
* 获取绑定字段
*/
export const getbindfieldlist = (data) => {
  return Axios({
    method: 'post',
    url: '/api/getbindfieldlist',
    data: data
  })
}
/*
* 查询绑定字段值
*/
export const getapprovalbindval = (data) => {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovalbindval',
    data: data
  })
}
/*
* 查询绑定字段值
*/
export const getdeptlist = (data) => {
  return Axios({
    method: 'post',
    url: '/api/getdeptlist',
    data: data
  })
}
/*
* 查询筛选配置
*/
export const getapprovalfieldoptions = (data) => {
  return Axios({
    method: 'post',
    url: '/api/getapprovalfieldoptions',
    data: data
  })
}
